module.exports = __webpack_public_path__ + "media/9.2a6c1b0d.mp3";